module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.metaMenu), function(dropdown, index) {
    return _c('dropdown', {
      attrs: {
        "modifierClass": null,
        "figureClass": dropdown.figureClass,
        "label": dropdown.label,
        "links": dropdown.links,
        "expanded": dropdown.expanded,
        "index": index,
        "image": dropdown.image
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c526076!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/partials/MenuGroup.vue
// module id = 703
// module chunks = 1